<template>
  <v-row>
    <v-col cols="12">
      <create-filter :account="account" />
    </v-col>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Current Filters
        </gg-card-header>
        <gg-card-text>
          <filter-table :account="account" />
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import CreateFilter from '@/components/Services/Hosting/Shared/Email/GlobalFilters/CreateFilter'
import FilterTable from '@/components/Services/Hosting/Shared/Email/GlobalFilters/Table'

export default {
  name: 'EmailFiltersManageView',
  components: {
    CreateFilter, FilterTable
  },
  computed: {
    account () {
      return this.$route.query.account
    }
  }
}
</script>
